import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function formatSignedNumber(value, digits = 0) {
  if (value == null || Number.isNaN(Number(value))) return null;
  const numericValue = Number(value);
  const rendered =
    digits > 0 ? numericValue.toFixed(digits) : String(Math.round(numericValue));
  return `${numericValue > 0 ? "+" : ""}${rendered}`;
}

export default function MatchOutcomeSummary({ summary = null }) {
  if (!summary) return null;

  const hasRating3Trend =
    summary.rating3?.before != null &&
    summary.rating3?.after != null;

  const hasReputationDelta = summary.reputation?.delta != null;
  const hasEloDelta = summary.elo?.change != null;

  if (!hasRating3Trend && !hasReputationDelta && !hasEloDelta) {
    return null;
  }

  return (
    <Box sx={{ marginTop: "0.35rem", display: "flex", flexDirection: "column", gap: "0.1rem" }}>
      {hasRating3Trend && (
        <Typography sx={{ fontSize: "0.7rem", color: "rgba(255,255,255,0.62)", lineHeight: 1.3 }}>
          R3 {summary.rating3.before.toFixed(2)} -&gt; {summary.rating3.after.toFixed(2)}
        </Typography>
      )}
      {hasReputationDelta && (
        <Typography
          sx={{
            fontSize: "0.7rem",
            color: summary.reputation.delta >= 0 ? "#00C853" : "#F44336",
            lineHeight: 1.3,
          }}
        >
          Rep {formatSignedNumber(summary.reputation.delta)}
        </Typography>
      )}
      {hasEloDelta && (
        <Typography sx={{ fontSize: "0.7rem", color: "rgba(255,255,255,0.62)", lineHeight: 1.3 }}>
          ELO {formatSignedNumber(summary.elo.change)}
        </Typography>
      )}
    </Box>
  );
}

MatchOutcomeSummary.propTypes = {
  summary: PropTypes.shape({
    elo: PropTypes.shape({
      change: PropTypes.number,
      after: PropTypes.number,
    }),
    rating3: PropTypes.shape({
      matchRating: PropTypes.number,
      before: PropTypes.number,
      after: PropTypes.number,
    }),
    reputation: PropTypes.shape({
      status: PropTypes.string,
      delta: PropTypes.number,
      before: PropTypes.number,
      after: PropTypes.number,
      dimensionsAffected: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
};

